import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import { useUserById } from "../Users/userUtils";
import { InvitationNetworkErrors, InvitationNotifications } from "./userInvitationUtils";

const pageDetails: PageWrapperProps = {
  className: "UserInvitation",
  headerText: "User Invitation"
};

export const UserInvitation = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { user, status, error, getUserById } = useUserById(id);

  if (status === "idle") {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Awaiting data...")}</h2>
      </PageWrapper>
    );
  }

  if (status === "loading") {
    return (
      <PageWrapper {...pageDetails}>
        <CircularProgress />
      </PageWrapper>
    );
  }

  if (status === "failed" || error) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Error")}</h2>
        <h3>{t(InvitationNetworkErrors.FetchInvitationError)}</h3>
        {error && <p>{error}</p>}
      </PageWrapper>
    );
  }

  if (status === "succeeded" && !user) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t(InvitationNotifications.InvitationNotFound)}</h2>
      </PageWrapper>
    );
  }

  if (status === "succeeded" && user) {
    return (
      <PageWrapper {...pageDetails}>
        <ul>
          <li>Email: {user.email}</li>
          <li>First Name: {user.firstName}</li>
          <li>Last Name: {user.lastName}</li>
          <li>Institution: {user.programMemberships?.items[0]?.program?.institution?.name || "-"}</li>
          <li>Program: {user.programMemberships?.items[0]?.program?.name}</li>
          {(user.programMemberships?.items[0]?.programRole === "Trainee" ||
            user.programMemberships?.items[0]?.programRole === "Attending") && (
            <li>NPI: {user.npi ?? "-"}</li>
          )}
          <li>
            Role:{" "}
            {user.programMemberships?.items[0]?.programRole}
          </li>
          {(user.programMemberships?.items[0]?.programRole === "Trainee" ||
            user.programMemberships?.items[0]?.programRole === "Attending") && (
            <li>
              Is Trainee in this program?:{" "}
              {user.programMemberships?.items[0]?.programRole === "Trainee" ? "Yes" : "No"}
            </li>
          )}
          {user.programMemberships?.items[0]?.programRole === "Trainee" && (
            <>
              <li>Trainee PGY: {user.pgy || "-"}</li>
              <li>
                Trainee Type:{" "}
                {user.programMemberships?.items[0]?.traineeType || "-"}
              </li>
            </>
          )}
          {(user.programMemberships?.items[0]?.programRole === "Trainee" ||
            user.programMemberships?.items[0]?.programRole === "Attending") && (
            <li>Job Title: {user.jobTitle || "-"}</li>
          )}
          <li>Status: {user.invitationStatus}</li>
        </ul>
      </PageWrapper>
    );
  }
  return <div>No criteria met</div>;
};
